/* =============================================================
   Pétale Lip Stain — minimal interactive JS
   - FAQ accordions are native <details>, no JS required.
   - Variant picker / add-to-cart hooks into the existing Shopify product form.
   - This file only handles enhancements that aren't covered by Liquid or CSS.
   ============================================================= */

(function () {
  'use strict';

  // ---------- Smooth scroll-to-form helper ----------
  function scrollToProductForm(e) {
    if (e) e.preventDefault();
    var form = document.querySelector('.lp-hero__form, .lp-product-page form[action*="/cart/add"]');
    if (!form) return;
    var top = form.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-lp-scroll-to-form]');
    if (link) scrollToProductForm(e);
  });

  // ---------- Review badge -> Judge.me review section ----------
  // Delegated, because the Judge.me widget is an app block that mounts after
  // this script runs: the target is resolved at click time, not at bind time.
  // If the widget isn't on the page we do NOT preventDefault, so the plain
  // #hash in the href still does something sensible.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-lp-review-link]');
    if (!link) return;
    var target = document.querySelector('#judgeme_product_reviews');
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  // ---------- Sticky mobile ATC visibility ----------
  // The colour swatch row is the hand-off point: once it is scrolled past,
  // the shopper has made the only choice the sticky bar can't show them.
  function lpStickyTrigger() {
    var groups = document.querySelectorAll('[data-option-index]');
    for (var i = 0; i < groups.length; i++) {
      var txt = (groups[i].textContent || '').toLowerCase();
      if (txt.indexOf('color') !== -1 || txt.indexOf('colour') !== -1) return groups[i];
    }
    return groups[0] || document.querySelector('.lp-hero__form');
  }

  // Keep the sticky button in lockstep with the real one rather than
  // recomputing price/availability a second way — two sources of truth for
  // "is this buyable and what does it cost" is how they end up disagreeing.
  function lpSyncStickyAtc(v) {
    var sticky = document.querySelector('[data-lp-sticky-add]');
    var real = document.querySelector('[data-lp-add-button]');
    if (!sticky || !real) return;

    var realLabel = real.querySelector('.lp-hero__atc-label');
    var realPrice = real.querySelector('.lp-hero__atc-price');
    var label = sticky.querySelector('[data-lp-sticky-label]');
    if (label && realLabel) label.textContent = realLabel.textContent.trim();
    sticky.disabled = !!real.disabled;

    // Two price slots: one inside the button (mobile) and one in the left
    // info block (desktop). Same value, different place per breakpoint.
    if (realPrice) {
      ['[data-lp-sticky-btn-price]', '[data-lp-sticky-price]'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el) el.innerHTML = realPrice.innerHTML;
      });
    }

    // Compare-at mirrors the hero's, including whether it is shown at all —
    // applyVariant already decided that, so don't re-derive it here.
    var cmp = document.querySelector('[data-lp-sticky-compare]');
    var heroCmp = document.querySelector('[data-lp-compare-price]');
    if (cmp && heroCmp) {
      var heroShown = heroCmp.style.display !== 'none' && heroCmp.textContent.trim() !== '';
      cmp.innerHTML = heroCmp.innerHTML;
      cmp.hidden = !heroShown;
    }

    // Thumbnail follows the variant (desktop only, but kept current either way).
    var img = document.querySelector('[data-lp-sticky-image]');
    if (img && v && v.featured_image && v.featured_image.src) img.src = v.featured_image.src;
  }

  // The sticky button is a proxy: click the real add-to-cart so the theme's
  // and Kaching's existing handlers fire unchanged.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lp-sticky-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var real = document.querySelector('[data-lp-add-button]');
    if (real && !real.disabled) { real.click(); return; }
    var form = document.querySelector('.lp-hero__form');
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  });

  function initStickyATC() {
    var sticky = document.querySelector('.lp-sticky-atc');
    if (!sticky) return;
    var trigger = lpStickyTrigger();
    if (!trigger) return;

    var ticking = false;
    function apply() {
      ticking = false;
      // On from the moment the swatches clear the top of the viewport, and
      // from there all the way down — no second threshold that would drop it
      // again near the end of the page.
      var past = trigger.getBoundingClientRect().bottom <= 0;
      sticky.classList.toggle('is-visible', past);
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      // rAF never fires while the document is hidden, which would freeze the
      // bar in whatever state it was last in. Fall back to a direct call.
      if (window.requestAnimationFrame && !document.hidden) window.requestAnimationFrame(apply);
      else apply();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    lpSyncStickyAtc();
    onScroll();
  }

  // ---------- Variant picker (only used if Liquid renders our custom picker) ----------
  function initVariantPicker(root) {
    var picker = root.querySelector('[data-lp-variant-picker]');
    if (!picker || picker.dataset.lpVariantBound === '1') return;
    picker.dataset.lpVariantBound = '1';

    var variants;
    try {
      var raw = picker.getAttribute('data-variants') || '[]';
      // The data attribute went through Liquid's `escape` filter; the browser
      // already decodes entities when reading via getAttribute, so JSON.parse works.
      variants = JSON.parse(raw);
    } catch (err) {
      console.warn('[lp variant picker] could not parse variants JSON', err);
      return;
    }

    var optionsCount = parseInt(picker.getAttribute('data-options-count') || '1', 10);

    // Parse optional bundle discount config so we can update the SAVE % badge on variant change.
    var optionNames = [];
    try { optionNames = JSON.parse(picker.getAttribute('data-option-names') || '[]'); } catch (_) {}
    var bundleKeywords = (picker.getAttribute('data-bundle-keywords') || 'bundle,pack,set,qty,quantity,size')
      .toLowerCase().split(',').map(function (k) { return k.trim(); }).filter(Boolean);
    var bundleDiscountMap = {};
    (picker.getAttribute('data-bundle-discount-map') || '').split('|').forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2) {
        var k = (kv[0] || '').trim().toLowerCase();
        var v = parseInt((kv[1] || '').trim(), 10);
        if (k && !isNaN(v)) bundleDiscountMap[k] = v;
      }
    });
    var discountBadgeTemplate = picker.getAttribute('data-discount-badge-template') || 'SAVE [%]%';
    var bundleIdx = -1;
    for (var bi = 0; bi < optionNames.length; bi++) {
      var nameLc = (optionNames[bi] || '').toLowerCase();
      for (var ki = 0; ki < bundleKeywords.length; ki++) {
        if (nameLc.indexOf(bundleKeywords[ki]) !== -1) { bundleIdx = bi; break; }
      }
      if (bundleIdx !== -1) break;
    }

    function computeBundlePercent(v) {
      if (!v || bundleIdx < 0 || !v.options) return 0;
      var val = (v.options[bundleIdx] || '').toLowerCase();
      var match = 0;
      Object.keys(bundleDiscountMap).forEach(function (key) {
        if (val.indexOf(key) !== -1) match = bundleDiscountMap[key];
      });
      return match;
    }

    // Savings map (variant id -> "Save €X,XX"), pre-formatted in Liquid with the
    // shop's money format so the value always matches the initial server render.
    var savingsMap = {};
    try { savingsMap = JSON.parse(picker.getAttribute('data-lp-savings-map') || '{}'); } catch (_) {}

    function updateDiscountBadge(v) {
      var badges = document.querySelectorAll('[data-lp-discount-badge]');
      if (!badges.length) return;
      var text = (v && savingsMap[v.id]) ? savingsMap[v.id] : '';
      badges.forEach(function (badge) {
        if (text) {
          badge.textContent = text;
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      });
    }

    function getIdInput() { return picker.closest('form') ? picker.closest('form').querySelector('input[name="id"]') : null; }
    function getPriceEl()   { return document.querySelector('.lp-hero__price[data-lp-price]'); }
    function getCompareEl() { return document.querySelector('[data-lp-compare-price]'); }
    function getAddBtn()    { return document.querySelector('[data-lp-add-button]'); }
    function getAtcPriceEl(){ return document.querySelector('.lp-hero__atc-price[data-lp-price]'); }

    function readSelected() {
      var values = [];
      for (var i = 1; i <= optionsCount; i++) {
        var active = picker.querySelector('[data-option-index="' + i + '"] .is-active');
        values.push(active ? active.getAttribute('data-option-value') : null);
      }
      return values;
    }

    function matchVariant(values) {
      return variants.find(function (v) {
        return v.options.every(function (val, idx) { return val === values[idx]; });
      });
    }

    function updateURL(v) {
      if (!v || !window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (_) {}
    }

    function applyVariant(v) {
      var addBtn = getAddBtn();
      var addText = addBtn ? (addBtn.getAttribute('data-add-text') || 'Add to bag') : 'Add to bag';
      var soldOutText = addBtn ? (addBtn.getAttribute('data-sold-out-text') || 'Sold out') : 'Sold out';

      if (!v) {
        if (addBtn) {
          var labelEl = addBtn.querySelector('.lp-hero__atc-label');
          if (labelEl) labelEl.textContent = 'Unavailable';
          else addBtn.textContent = 'Unavailable';
          addBtn.disabled = true;
        }
        return;
      }

      var idInput = getIdInput();
      if (idInput) idInput.value = v.id;

      var priceEl = getPriceEl();
      if (priceEl) priceEl.innerHTML = formatMoney(v.price);

      var atcPriceEl = getAtcPriceEl();
      if (atcPriceEl) atcPriceEl.innerHTML = formatMoney(v.price);

      var compareEl = getCompareEl();
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price !== v.price) {
          compareEl.innerHTML = formatMoney(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !v.available;
        var lbl = addBtn.querySelector('.lp-hero__atc-label');
        if (lbl) lbl.textContent = v.available ? addText : soldOutText;
        else addBtn.textContent = v.available ? addText : soldOutText;
        addBtn.classList.toggle('is-disabled', !v.available);
      }

      // Sticky mobile ATC
      var stickyPrice = document.querySelector('.lp-sticky-atc [data-lp-price]');
      if (stickyPrice) stickyPrice.innerHTML = formatMoney(v.price);
      var stickySub = document.querySelector('.lp-sticky-atc__sub');
      if (stickySub && v.title) stickySub.textContent = v.title + ' · ' + formatMoneyPlain(v.price);

      // Refresh SAVE badge (monetary savings from the pre-formatted map)
      updateDiscountBadge(v);

      // Refresh info-bar title (uses the source configured in the section schema)
      var titleEl = document.querySelector('[data-lp-info-title]');
      if (titleEl && v) {
        var src = (picker.getAttribute('data-info-title-source') || 'variant');
        if (src === 'bundle' && bundleIdx >= 0 && v.options) {
          titleEl.textContent = v.options[bundleIdx] || v.title;
        } else if (src === 'product') {
          // product title is static — no change needed
        } else if (v.title) {
          titleEl.textContent = v.title;
        }
      }

      // Refresh the "More info" bundle quantity on single-product bundles
      // (Luxury Cotton Bath Towels / Hand Towels / Washcloths). The number is
      // read from the SAME bundle option index this file already resolves, so a
      // COLOUR change re-reads the identical value and the quantity never
      // shifts. Cross-bundle products render no [data-lp-mi-qty] and have no
      // bundle option at all, so this is a no-op there. Only the text node
      // inside the existing popover is touched — the popover is never rebuilt,
      // reopened or closed.
      var miQtyEl = document.querySelector('[data-lp-mi-qty]');
      if (miQtyEl && bundleIdx >= 0 && v.options) {
        var miMatch = String(v.options[bundleIdx] || '').match(/\d+/);
        if (miMatch) miQtyEl.textContent = miMatch[0];
      }

      // Re-filter slides and thumbs for the new selection, then reset the
      // carousel to slide 0 — which the `order` ranks guarantee is this
      // variant's own product shot.
      //
      // animate:false is deliberate. Sliding across a set that just changed
      // would pan over the OLD variant's images on the way, which is exactly
      // the flash of stale colour we must not show.
      lpApplyGalleryFilter(v);
      lpCarouselSync({ reset: true, animate: false });
      lpSyncStickyAtc(v);

      updateURL(v);
    }

    // Format from Shopify's integer cents → display string. Falls back to Shopify's pre-formatted price string.
    function formatMoney(price) {
      if (typeof price === 'string') return price; // already formatted (Liquid `money` filter output)
      if (typeof price !== 'number') return '';

      var shop = window.Shopify || {};
      var currency = (shop.currency && shop.currency.active) || (shop.activeCurrency) || 'USD';
      var locale = shop.locale || document.documentElement.lang || navigator.language || 'en-US';
      var whole = Math.round(price / 100);

      try {
        // narrowSymbol => plain "$" instead of "NZ$/AU$/CA$".
        // Force 2 decimals (always ".00" on rounded whole prices) for consistency.
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'narrowSymbol',
          maximumFractionDigits: 2,
          minimumFractionDigits: 2
        }).format(whole);
      } catch (_) {
        // Fallback: shop currency symbol from window.Shopify or just "$"
        var sym = (shop.currency && shop.currency.symbol) || '$';
        return sym + whole + '.00';
      }
    }
    function formatMoneyPlain(price) { return formatMoney(price).replace(/<[^>]+>/g, ''); }

    function handleSelect(btn) {
      var parent = btn.closest('[data-option-index]');
      if (!parent) return;
      parent.querySelectorAll('[data-option-value]').forEach(function (el) {
        el.classList.remove('is-active');
        if (el.hasAttribute('aria-checked')) el.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-active');
      if (btn.hasAttribute('aria-checked')) btn.setAttribute('aria-checked', 'true');
      var label = parent.querySelector('.lp-selected-value');
      if (label) label.textContent = btn.getAttribute('data-option-value');
      var v = matchVariant(readSelected());
      applyVariant(v);
    }

    // Sets every option button to match a given variant's options, then applies it.
    // Used when a gallery image (linked to a variant) is clicked.
    function selectVariant(v) {
      if (!v || !v.options) return;
      for (var i = 1; i <= optionsCount; i++) {
        var optEl = picker.querySelector('[data-option-index="' + i + '"]');
        if (!optEl) continue;
        var wantVal = v.options[i - 1];
        var matchBtn = null;
        optEl.querySelectorAll('[data-option-value]').forEach(function (el) {
          if (el.getAttribute('data-option-value') === wantVal) matchBtn = el;
        });
        if (matchBtn) {
          optEl.querySelectorAll('[data-option-value]').forEach(function (el) {
            el.classList.remove('is-active');
            if (el.hasAttribute('aria-checked')) el.setAttribute('aria-checked', 'false');
          });
          matchBtn.classList.add('is-active');
          if (matchBtn.hasAttribute('aria-checked')) matchBtn.setAttribute('aria-checked', 'true');
          var label = optEl.querySelector('.lp-selected-value');
          if (label) label.textContent = wantVal;
        }
      }
      applyVariant(matchVariant(readSelected()));
    }

    // Build a media-id → variant map so clicking a product image selects the
    // variant that image is assigned to (and updates price + discount).
    // EDITORIAL FIRST: media flagged as editorial never enters this map, so it can
    // never be resolved to a color / bundle / variant.
    var mediaToVariant = {};
    variants.forEach(function (v) {
      if (v.featured_media && v.featured_media.id != null && !lpIsEditorialMediaId(v.featured_media.id)) {
        mediaToVariant[String(v.featured_media.id)] = v;
      }
      if (v.featured_image && v.featured_image.id != null && !lpIsEditorialMediaId(v.featured_image.id)) {
        // featured_image.id and featured_media.id differ; index both for safety
        mediaToVariant[String(v.featured_image.id)] = mediaToVariant[String(v.featured_image.id)] || v;
      }
    });

    // Expose for the gallery: given a media id, select the matching variant.
    picker.__lpSelectVariantByMedia = function (mediaId) {
      // EDITORIAL FIRST: editorial media is standalone gallery media — it must
      // never drive color / bundle / variant selection.
      if (lpIsEditorialMediaId(mediaId)) return false;
      var v = mediaToVariant[String(mediaId)];
      if (v) { selectVariant(v); return true; }
      return false;
    };

    // Bind each option button directly. Use capture phase + stopPropagation so the
    // host theme's product-form web component can't swallow the click.
    picker.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        handleSelect(btn);
      }, true);
      btn.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          handleSelect(btn);
        }
      });
    });

    // No initial applyVariant — the Liquid template already rendered the correct
    // price/ID/label for selected_or_first_available_variant. We only patch on click.
  }

  // ---------- Quantity stepper ----------
  function initQty(root) {
    root.querySelectorAll('.lp-qty').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-lp-qty-minus]');
      var plus = wrap.querySelector('[data-lp-qty-plus]');
      if (!input) return;
      minus && minus.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      plus && plus.addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // ---------- Gallery thumb switching (for lp-hero) ----------
  // Flash-free hero image swapping for variants / bundles / thumbnails.
  // Every gallery image is preloaded up front and new images are crossfaded in
  // only after they have fully decoded, so the current image stays put until the
  // next one is ready — no blank, pink, or half-loaded frame. Loaded images are
  // held in a cache map so they are never re-fetched when switching back.
  var lpImgCache = Object.create(null);

  function lpBaseName(u) {
    return String(u || '').split('?')[0].split('/').pop().split('.')[0];
  }

  /* =============================================================
     EDITORIAL MEDIA  ([editorial] ALT marker)
     -------------------------------------------------------------
     Opt-in per section via the `enable_editorial_media` setting; the
     Liquid snippet then renders data-lp-editorial-enabled="true" on
     .lp-hero__gallery and data-lp-editorial="true" on every thumb whose
     Shopify ALT text contains "[editorial]".

     Classification runs BEFORE any color / bundle / variant parsing:
       - editorial media never enters the media -> variant map,
       - editorial media never selects a variant when clicked,
       - while an editorial image is the active media, the save badge,
         bundle label, More info link and info icon are hidden.
     Media without the marker is completely untouched.
     ============================================================= */
  var LP_EDITORIAL_RE = /\[\s*editorial\s*\]/i;
  var lpEditorialBySrc = null;
  var lpEditorialByMediaId = null;

  function lpEditorialGallery() {
    return document.querySelector('.lp-hero__gallery[data-lp-editorial-enabled="true"]');
  }

  function lpBuildEditorialIndex() {
    lpEditorialBySrc = Object.create(null);
    lpEditorialByMediaId = Object.create(null);
    var gallery = lpEditorialGallery();
    if (!gallery) return;
    gallery.querySelectorAll('.lp-hero__thumb[data-lp-editorial="true"]').forEach(function (t) {
      var key = lpBaseName(t.getAttribute('data-src'));
      if (key) lpEditorialBySrc[key] = true;
      var id = t.getAttribute('data-media-id');
      if (id) lpEditorialByMediaId[String(id)] = true;
    });
  }

  function lpIsEditorialMediaId(mediaId) {
    if (mediaId == null) return false;
    if (!lpEditorialByMediaId) lpBuildEditorialIndex();
    return !!(lpEditorialByMediaId && lpEditorialByMediaId[String(mediaId)]);
  }

  function lpIsEditorialSrc(src) {
    if (!src) return false;
    if (!lpEditorialBySrc) lpBuildEditorialIndex();
    return !!(lpEditorialBySrc && lpEditorialBySrc[lpBaseName(src)]);
  }

  function lpIsEditorialAlt(alt) {
    return LP_EDITORIAL_RE.test(String(alt == null ? '' : alt));
  }

  // The "[editorial]" marker is internal — it must never reach the rendered alt.
  function lpCleanAlt(alt) {
    if (alt == null) return alt;
    return String(alt).replace(LP_EDITORIAL_RE, '').replace(/\s{2,}/g, ' ').trim();
  }

  // Toggle the gallery overlay state. Called synchronously before any image swap
  // starts, so the save badge / bundle label / More info / info icon disappear on
  // the same frame the editorial image is requested (no flash, no delay) and come
  // back on the same frame a product image is requested (no stale overlay).
  function lpSetEditorialState(isEditorial) {
    var gallery = lpEditorialGallery();
    if (!gallery) return;
    gallery.classList.toggle('is-lp-editorial', !!isEditorial);
    if (!isEditorial) return;
    // Never leave the "More info" popover open behind an editorial image.
    var pop = gallery.querySelector('[data-lp-info-popover]');
    if (pop && !pop.hidden) {
      pop.hidden = true;
      var toggle = gallery.querySelector('[data-lp-info-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  }

  // Resolve the editorial state from whatever the main image is showing right now.
  // Used on initial page load and as a safety net after programmatic changes.
  function lpSyncEditorialFromCurrent() {
    var gallery = lpEditorialGallery();
    if (!gallery) return;
    var img = gallery.querySelector('.lp-hero__main img');
    if (!img) return;
    lpSetEditorialState(
      lpIsEditorialSrc(img.currentSrc || img.getAttribute('src')) ||
      lpIsEditorialAlt(img.getAttribute('alt'))
    );
  }

  function lpPreload(src) {
    if (!src) return null;
    var key = lpBaseName(src);
    var cached = lpImgCache[key];
    if (cached && cached.src === src) return cached;
    var img = new Image();
    img.decoding = 'async';
    img.src = src;
    lpImgCache[key] = img;
    return img;
  }

  // Preload every image the gallery can show for a variant / bundle selection:
  // the main-size thumbnail images and each variant's featured image.
  function lpPreloadAllHero() {
    document.querySelectorAll('.lp-hero__thumb[data-src]').forEach(function (t) {
      lpPreload(t.getAttribute('data-src'));
    });
    var picker = document.querySelector('[data-lp-variant-picker]');
    if (!picker) return;
    try {
      var variants = JSON.parse(picker.getAttribute('data-variants') || '[]');
      variants.forEach(function (v) {
        if (v && v.featured_image && v.featured_image.src) lpPreload(v.featured_image.src);
      });
    } catch (e) {}
  }

  // Crossfade the main hero image to `src`. The base <img> keeps showing the
  // current image until the new one has decoded; then the new image is faded in
  // on an overlay and committed to the base. Never shows an empty/pink/broken state.
  function lpCrossfadeHero(src, alt) {
    // COMPAT SHIM. The gallery used to crossfade one <img>; it is now a slide
    // track. Every historic caller passes a source, so resolve it to the slide
    // showing that image and navigate there. Kept under the old name so the
    // public window.lpSwapHeroImage contract and any theme code calling it
    // keep working unchanged.
    if (!src) return;
    lpCarouselGoToSrc(src);
  }

  // Shared entry point so the separate variant-scroll helper uses the same swap.
  window.lpSwapHeroImage = lpCrossfadeHero;

  // Public helper so the variant picker can also drive image swaps.
  function setHeroImage(src, alt) {
    // Same shim rationale as lpCrossfadeHero: resolve a source to its slide.
    // The old mobile scroll-to-top behaviour stays opt-in via __lpVariantScroll.
    if (!src) return;
    lpCarouselGoToSrc(src);
    if (window.__lpVariantScroll && window.matchMedia && window.matchMedia('(max-width: 720px)').matches) {
      var host = document.querySelector('.lp-hero__main');
      if (host) {
        var top = host.getBoundingClientRect().top + window.pageYOffset - 12;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }
  }
  function setActiveThumb(matcher) {
    document.querySelectorAll('.lp-hero__thumb').forEach(function (t) {
      var ts = t.getAttribute('data-src') || '';
      t.classList.toggle('is-active', matcher(ts, t));
    });
  }

  // ---- VARIANT-FILTERED GALLERY -------------------------------------------
  // Mirror of the Liquid rule in lp-hero-content.liquid: show only the media
  // that belongs to the current selection. Liquid renders the first paint
  // already filtered; this re-runs on every selection change.
  //
  //   variant media   -> only the selected variant's own image (colour AND
  //                      quantity, since each variant owns exactly one shot)
  //   editorial media -> only the items whose ALT names the selected colour
  //   generic media   -> always visible (assigned to no variant, no colour)
  //
  // Any thumb missing data-lp-media-kind is left alone, so a gallery rendered
  // before this setting existed keeps its old behaviour.
  /* =============================================================
     GALLERY CAROUSEL
     -------------------------------------------------------------
     Scroll-snap based, and deliberately so.

     The first cut translated a track. It did not work: something
     else on this page continuously resets BOTH `transform` and
     `translate` on that element back to zero — it shows up as a
     permanently "running" CSSTransition on transform, and the rule
     responsible lives in one of the 9 cross-origin stylesheets, so
     it cannot be overridden from here (even !important lost).

     Native scrolling is immune to that fight, and it also hands us
     real touch swipe, momentum, and correct vertical-scroll
     passthrough for free instead of reimplementing them.

     Position IS the scroll offset; index = scrollLeft / slide width.
     Filtered-out slides are display:none, so they add no scroll
     width and the index math never needs to know about them.
     ============================================================= */
  var LP_SLIDE_MS = 300;

  function lpCarouselRoot() {
    return document.querySelector('.lp-hero__gallery');
  }

  function lpCarouselParts(gallery) {
    if (!gallery) return null;
    var track = gallery.querySelector('[data-lp-track]');
    var viewport = gallery.querySelector('[data-lp-viewport]');
    if (!track || !viewport) return null;
    return {
      gallery: gallery,
      track: track,
      viewport: viewport,
      counter: gallery.querySelector('[data-lp-counter]'),
      fill: gallery.querySelector('[data-lp-progress-fill]')
    };
  }

  // Visible slides in PAINT order. Flex `order` means DOM order is not
  // visual order, and scroll position follows the visual one.
  function lpVisibleSlides(gallery) {
    var all = Array.prototype.slice.call(gallery.querySelectorAll('[data-lp-slide]'));
    // Read the EFFECTIVE order, not the inline attribute: lp-product-page.css
    // remaps ranks per breakpoint (desktop >=981px and mobile <=980px each have
    // their own sequence), so the inline value is only the Liquid base and can
    // differ from what the user sees. Reading it directly desynced swipe, the
    // counter and the transform math from the visual sequence.
    // Resolved once per slide, not inside the comparator, which would otherwise
    // force a style recalc on every comparison.
    var ranked = all
      .filter(function (s) { return !s.hidden; })
      .map(function (s, i) {
        var n = parseInt(window.getComputedStyle(s).order, 10);
        if (isNaN(n)) n = parseInt(s.style.order || '0', 10);
        return { el: s, order: isNaN(n) ? 0 : n, dom: all.indexOf(s) };
      });
    ranked.sort(function (a, b) {
      if (a.order !== b.order) return a.order - b.order;
      return a.dom - b.dom;   // stable within a rank
    });
    return ranked.map(function (r) { return r.el; });
  }

  function lpReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // The counter clears the info bar, whose height is theme-setting driven —
  // measure it rather than hard-coding a guess.
  function lpMeasureInfoBar(gallery) {
    if (!gallery) return;
    var bar = gallery.querySelector('.lp-hero__info-bar');
    var h = bar && !bar.hidden ? Math.round(bar.getBoundingClientRect().height) : 0;
    gallery.style.setProperty('--lp-info-bar-h', h + 'px');

    // .lp-hero__main draws a frame whose width is a theme setting. The desktop
    // thumbnail column insets by the same amount so thumb #1 lines up with the
    // top of the IMAGE rather than the top of the frame.
    var main = gallery.querySelector('.lp-hero__main');
    var b = main ? parseFloat(getComputedStyle(main).borderTopWidth) || 0 : 0;
    gallery.style.setProperty('--lp-main-border', Math.round(b) + 'px');
  }

  function lpScrollThumbIntoView(gallery, thumb) {
    var strip = gallery.querySelector('.lp-hero__thumbs');
    if (!strip || !thumb) return;
    var vertical = strip.scrollHeight > strip.clientHeight + 1;
    var horizontal = strip.scrollWidth > strip.clientWidth + 1;
    if (!vertical && !horizontal) return;        // nothing to scroll, never touch the page
    var tr = thumb.getBoundingClientRect();
    var sr = strip.getBoundingClientRect();
    var behavior = lpReducedMotion() ? 'auto' : 'smooth';
    if (vertical) {
      if (tr.top < sr.top) strip.scrollBy({ top: tr.top - sr.top - 8, behavior: behavior });
      else if (tr.bottom > sr.bottom) strip.scrollBy({ top: tr.bottom - sr.bottom + 8, behavior: behavior });
    } else {
      if (tr.left < sr.left) strip.scrollBy({ left: tr.left - sr.left - 8, behavior: behavior });
      else if (tr.right > sr.right) strip.scrollBy({ left: tr.right - sr.right + 8, behavior: behavior });
    }
  }

  // Distance from the scroller's content origin to this slide. Measured rather
  // than computed as index*width, because with the peek gutter a slide is
  // narrower than the viewport — and the LAST slide can never scroll all the
  // way to the left edge, so index*width would mis-identify it.
  function lpSlideOffset(parts, slide) {
    return slide.getBoundingClientRect().left
         - parts.viewport.getBoundingClientRect().left
         + parts.viewport.scrollLeft;
  }

  function lpNearestIndex(parts, slides) {
    var x = parts.viewport.scrollLeft;
    var best = 0, bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var d = Math.abs(lpSlideOffset(parts, slides[i]) - x);
      if (d < bestDist) { bestDist = d; best = i; }
    }
    return best;
  }

  // Reflect scroll position into the counter, position bar, thumbs and
  // overlay state. Cheap and idempotent: safe to call on every scroll frame.
  function lpCarouselUpdateUI() {
    var gallery = lpCarouselRoot();
    var parts = lpCarouselParts(gallery);
    if (!parts) return;
    var slides = lpVisibleSlides(gallery);
    var n = slides.length;
    if (!n) return;

    var i = lpNearestIndex(parts, slides);
    gallery.__lpIndex = i;

    var active = slides[i];

    // Clear is-active across ALL slides, not just the visible ones: after a
    // variant change the previously-active slide is hidden, and toggling only
    // over the visible set would leave its flag set forever.
    Array.prototype.slice.call(gallery.querySelectorAll('[data-lp-slide]'))
      .forEach(function (s) { s.classList.remove('is-active'); });
    active.classList.add('is-active');

    slides.forEach(function (s, k) {
      var img = s.querySelector('img');
      if (img && Math.abs(k - i) <= 1) img.loading = 'eager';   // neighbours ready to swipe to
    });

    var mediaId = active.getAttribute('data-media-id');
    Array.prototype.slice.call(gallery.querySelectorAll('.lp-hero__thumb')).forEach(function (t) {
      var on = t.getAttribute('data-media-id') === mediaId;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-current', on ? 'true' : 'false');
      if (on) lpScrollThumbIntoView(gallery, t);
    });

    if (parts.counter) parts.counter.textContent = (i + 1) + ' / ' + n;
    if (parts.fill) {
      // width + margin rather than a transform: transform is exactly what the
      // page fights us over on this subtree (see the header comment).
      parts.fill.style.width = (100 / n) + '%';
      parts.fill.style.marginLeft = (i * (100 / n)) + '%';
    }

    lpSetEditorialState(
      active.getAttribute('data-lp-editorial') === 'true' ||
      lpIsEditorialAlt(active.getAttribute('data-alt'))
    );
  }

  // Own the easing so the duration is the spec'd ~300ms rather than the
  // browser's variable native smooth-scroll. Snap is suspended for the
  // duration, otherwise it fights a scripted scroll mid-flight.
  function lpAnimateScroll(gallery, parts, to) {
    var vp = parts.viewport;
    var from = vp.scrollLeft;
    var dist = to - from;
    if (Math.abs(dist) < 1) { lpCarouselUpdateUI(); return; }
    if (gallery.__lpRaf) cancelAnimationFrame(gallery.__lpRaf);

    // requestAnimationFrame does not fire while the document is hidden, which
    // would strand the gallery mid-move with snapping switched off. Land on the
    // target immediately instead — there is nobody watching the animation.
    if (document.hidden) {
      vp.scrollLeft = to;
      vp.style.scrollSnapType = '';
      lpCarouselUpdateUI();
      return;
    }

    vp.style.scrollSnapType = 'none';
    var t0 = 0;
    function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / LP_SLIDE_MS);
      var e = 1 - Math.pow(1 - k, 3);            // ease-out cubic
      vp.scrollLeft = from + dist * e;
      lpCarouselUpdateUI();
      if (k < 1) {
        gallery.__lpRaf = requestAnimationFrame(step);
      } else {
        gallery.__lpRaf = null;
        vp.style.scrollSnapType = '';
        lpCarouselUpdateUI();
      }
    }
    gallery.__lpRaf = requestAnimationFrame(step);
  }

  function lpCarouselGoTo(index, opts) {
    var gallery = lpCarouselRoot();
    var parts = lpCarouselParts(gallery);
    if (!parts) return;
    opts = opts || {};
    var slides = lpVisibleSlides(gallery);
    var n = slides.length;
    if (!n) return;

    var i = ((index % n) + n) % n;               // wrap both directions
    var maxScroll = parts.viewport.scrollWidth - parts.viewport.clientWidth;
    var target = Math.max(0, Math.min(maxScroll, lpSlideOffset(parts, slides[i])));

    if (opts.animate === false || lpReducedMotion()) {
      if (gallery.__lpRaf) { cancelAnimationFrame(gallery.__lpRaf); gallery.__lpRaf = null; }
      var vp = parts.viewport;
      vp.style.scrollSnapType = 'none';          // snap would re-settle a jump
      vp.scrollLeft = target;
      vp.style.scrollSnapType = '';
      lpCarouselUpdateUI();
    } else {
      lpAnimateScroll(gallery, parts, target);
    }
  }

  // Resolve an image source to its slide. Keeps the historic
  // setHeroImage / lpSwapHeroImage callers working.
  function lpCarouselGoToSrc(src) {
    var gallery = lpCarouselRoot();
    if (!gallery || !src) return false;
    var slides = lpVisibleSlides(gallery);
    var key = lpBaseName(src);
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (img && lpBaseName(img.getAttribute('src')) === key) {
        lpCarouselGoTo(i);
        return true;
      }
    }
    return false;
  }

  // Call after anything changes which slides are visible.
  function lpCarouselSync(opts) {
    opts = opts || {};
    var gallery = lpCarouselRoot();
    var parts = lpCarouselParts(gallery);
    if (!parts) return;
    var n = lpVisibleSlides(gallery).length;
    gallery.setAttribute('data-lp-single', n <= 1 ? 'true' : 'false');
    lpMeasureInfoBar(gallery);
    lpCarouselGoTo(opts.reset ? 0 : (gallery.__lpIndex || 0), { animate: opts.animate });
  }

  function lpCarouselInit() {
    var gallery = lpCarouselRoot();
    var parts = lpCarouselParts(gallery);
    if (!parts || gallery.dataset.lpCarouselBound === '1') return;
    gallery.dataset.lpCarouselBound = '1';

    Array.prototype.slice.call(gallery.querySelectorAll('[data-lp-nav]')).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var dir = btn.getAttribute('data-lp-nav') === 'next' ? 1 : -1;
        lpCarouselGoTo((gallery.__lpIndex || 0) + dir);
      });
    });

    // Native swipe already moves the scroller; just mirror it into the UI.
    // Updating directly (rather than inside requestAnimationFrame) keeps this
    // correct in a backgrounded tab, where rAF never runs. The trailing timer
    // guarantees the settled position is the one we end up reflecting.
    var uiTimer = null;
    parts.viewport.addEventListener('scroll', function () {
      lpCarouselUpdateUI();
      if (uiTimer) clearTimeout(uiTimer);
      uiTimer = setTimeout(function () { uiTimer = null; lpCarouselUpdateUI(); }, 60);
    }, { passive: true });

    parts.viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); lpCarouselGoTo((gallery.__lpIndex || 0) - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); lpCarouselGoTo((gallery.__lpIndex || 0) + 1); }
    });

    // Slide width is the viewport width, so a resize invalidates the offset.
    window.addEventListener('resize', function () {
      lpMeasureInfoBar(gallery);
      lpCarouselGoTo(gallery.__lpIndex || 0, { animate: false });
    });

    // Server render is already on the right slide; adopt it without animating.
    lpCarouselSync({ reset: false, animate: false });
  }

  function lpFilteredGallery() {
    return document.querySelector('.lp-hero__gallery[data-lp-gallery-filter="true"]');
  }

  function lpApplyGalleryFilter(v) {
    var gallery = lpFilteredGallery();
    if (!gallery || !v) return;

    var colorIdx = parseInt(gallery.getAttribute('data-lp-color-index'), 10);
    var color = '';
    if (!isNaN(colorIdx) && colorIdx >= 0 && v.options && v.options[colorIdx] != null) {
      color = String(v.options[colorIdx]).toLowerCase().trim();
    }

    // featured_media is the gallery-level id the thumbs carry; featured_image.id
    // is a different number, so only the former can be compared to data-media-id.
    var variantMediaId =
      v.featured_media && v.featured_media.id != null ? String(v.featured_media.id) : '';

    // Slides and thumbs describe the same media and must be filtered as one
    // set — a slide left visible without its thumb (or vice versa) desyncs the
    // counter, the position bar and the index math behind every transform.
    var items = gallery.querySelectorAll('.lp-hero__thumb, [data-lp-slide]');
    Array.prototype.slice.call(items).forEach(function (el) {
      var kind = el.getAttribute('data-lp-media-kind');
      if (!kind) return;
      var show = true;
      if (kind === 'excluded') {
        // Liquid could not place this in one of the seven slots, or could not tie
        // it to a colour. It must stay hidden through variant changes too.
        show = false;
      } else if (kind === 'editorial') {
        var itemColor = (el.getAttribute('data-lp-color') || '').toLowerCase().trim();
        // No colour on either side = can't rule it out, so keep it visible.
        show = !itemColor || !color || itemColor === color;
      } else if (kind === 'variant') {
        // If the variant has no media of its own, don't blank the gallery.
        show = !variantMediaId || el.getAttribute('data-media-id') === variantMediaId;
      }
      el.hidden = !show;
    });
  }

  function initGallery(root) {
    var gallery = root.querySelector('.lp-hero__gallery');
    if (!gallery || gallery.dataset.lpGalleryBound === '1') return;
    gallery.dataset.lpGalleryBound = '1';

    var thumbs = gallery.querySelectorAll('.lp-hero__thumb');
    var picker = document.querySelector('[data-lp-variant-picker]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var src = t.getAttribute('data-src');
        var alt = t.getAttribute('data-alt') || '';
        if (!src) return;

        // EDITORIAL FIRST: classify this media before anything else reads it.
        var isEditorial = t.getAttribute('data-lp-editorial') === 'true' || lpIsEditorialAlt(alt);

        // Navigate the carousel to this thumb's slide. lpCarouselGoTo owns the
        // is-active state on both slides and thumbs, so don't set it by hand.
        var mediaIdForSlide = t.getAttribute('data-media-id');
        var slides = lpVisibleSlides(gallery);
        var idx = -1;
        for (var si = 0; si < slides.length; si++) {
          if (slides[si].getAttribute('data-media-id') === mediaIdForSlide) { idx = si; break; }
        }
        if (idx >= 0) lpCarouselGoTo(idx);
        else lpCarouselGoToSrc(src);

        // Editorial media is standalone: it must not inherit or drive any
        // color / bundle / variant state, so stop here for it.
        if (isEditorial) return;

        // If this image is linked to a variant, also SELECT that variant
        // (updates price, SAVE discount badge, ATC, URL, etc.).
        var mediaId = t.getAttribute('data-media-id');
        if (mediaId && picker && typeof picker.__lpSelectVariantByMedia === 'function') {
          picker.__lpSelectVariantByMedia(mediaId);
        }
      });
    });
  }

  // ---------- Before / after slider ----------
  function initBeforeAfter() {
    document.querySelectorAll('.lp-ba__slider[data-lp-slider]').forEach(function (slider) {
      if (slider.dataset.lpBaBound === '1') return;
      slider.dataset.lpBaBound = '1';

      // Prevent native image drag (which was hijacking mousedown on desktop)
      slider.querySelectorAll('img').forEach(function (img) {
        img.draggable = false;
        img.setAttribute('draggable', 'false');
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });

      function setPos(clientX) {
        var rect = slider.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
        slider.style.setProperty('--lp-ba-pos', pct + '%');
      }

      var dragging = false;

      // Pointer Events (modern browsers — unified mouse + touch + pen)
      slider.addEventListener('pointerdown', function (e) {
        dragging = true;
        setPos(e.clientX);
        try { slider.setPointerCapture(e.pointerId); } catch (err) {}
        e.preventDefault();
      });
      slider.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(e.clientX);
        e.preventDefault();
      });
      var endDrag = function () { dragging = false; };
      slider.addEventListener('pointerup',      endDrag);
      slider.addEventListener('pointercancel',  endDrag);
      slider.addEventListener('pointerleave',   endDrag);

      // Fallback: explicit mouse events for legacy desktop browsers where
      // Pointer Events might be intercepted by image drag or unsupported.
      slider.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return; // left-click only
        dragging = true;
        setPos(e.clientX);
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (dragging) setPos(e.clientX);
      });
      document.addEventListener('mouseup', function () { dragging = false; });

      // Click-to-jump — feels more responsive than pure drag-only
      slider.addEventListener('click', function (e) {
        setPos(e.clientX);
      });

      // Keyboard: left/right arrow keys nudge the slider (accessibility)
      slider.setAttribute('tabindex', '0');
      slider.addEventListener('keydown', function (e) {
        var cur = parseFloat(slider.style.getPropertyValue('--lp-ba-pos')) || 50;
        if (e.key === 'ArrowLeft')  { slider.style.setProperty('--lp-ba-pos', Math.max(0,  cur - 5) + '%'); e.preventDefault(); }
        if (e.key === 'ArrowRight') { slider.style.setProperty('--lp-ba-pos', Math.min(100, cur + 5) + '%'); e.preventDefault(); }
      });
    });
  }

  // ---------- Countdown (optional, very lightweight) ----------
  function initCountdown() {
    document.querySelectorAll('[data-lp-countdown-target]').forEach(function (el) {
      var target = parseInt(el.getAttribute('data-lp-countdown-target'), 10);
      if (!target) return;
      function tick() {
        var diff = Math.max(0, target - Date.now());
        var s = Math.floor(diff / 1000);
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60);   s -= m * 60;
        el.innerHTML =
          '<span>' + String(h).padStart(2, '0') + 'h</span>' +
          '<span>' + String(m).padStart(2, '0') + 'm</span>' +
          '<span>' + String(s).padStart(2, '0') + 's</span>';
      }
      tick();
      // In the Shopify theme editor (design mode), a per-second DOM update makes
      // the editor re-render the section on a loop — this is the whole-page flicker
      // seen while editing. Render the countdown once and skip the live timer in the
      // editor; the live storefront still ticks every second as normal.
      if (window.Shopify && window.Shopify.designMode) return;
      setInterval(tick, 1000);
    });
  }

  // ---------- Info-bar popover (over main hero image) ----------
  function initInfoBar() {
    document.querySelectorAll('[data-lp-info-toggle]').forEach(function (btn) {
      if (btn.dataset.lpInfoBound === '1') return;
      btn.dataset.lpInfoBound = '1';
      var bar = btn.closest('.lp-hero__info-bar');
      var pop = bar && bar.querySelector('[data-lp-info-popover]');
      if (!pop) return;

      function open() {
        pop.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
      }
      function close() {
        pop.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (pop.hidden) open(); else close();
      });

      var closeBtn = pop.querySelector('[data-lp-info-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          close();
        });
      }

      // Close on outside click or Escape
      document.addEventListener('click', function (e) {
        if (pop.hidden) return;
        if (!pop.contains(e.target) && !btn.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !pop.hidden) close();
      });
    });
  }

  // ---------- Editorial safety net ----------
  // Watches the main hero image so ANY change — including a future navigation
  // control or a programmatic swap that doesn't go through lpCrossfadeHero — still
  // resolves the correct overlay state. The crossfade overlay is inspected the
  // moment it is inserted, so the state flips on the first frame of the fade.
  function initEditorialWatcher() {
    // No-op since the carousel landed. Editorial state used to be inferred by
    // watching the single hero <img> swap its src; lpCarouselGoTo now sets it
    // directly from the active slide, which is both earlier and exact.
  }

  // ---------- Boot ----------
  function init() {
    // Each section that uses lp-* renders its own .lp-product-page wrapper, so
    // there are several on the page (announcement bar, hero, etc). We must scan
    // from `document`, not the first matching wrapper.
    lpBuildEditorialIndex();
    lpPreloadAllHero();
    initVariantPicker(document);
    initQty(document);
    initGallery(document);
    lpCarouselInit();
    initBeforeAfter();
    initCountdown();
    initStickyATC();
    initInfoBar();
    initEditorialWatcher();
    lpSyncEditorialFromCurrent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();